import { Box, H5, H6, Text, Card, Stack } from "@adfenix/alexandria";
import { TemplateService } from "@adfenix/types";
import { useGetImageTemplates } from "api/queries/templateService";
import { useOfficeAndHq } from "hooks/useOfficeAndHq";
import { Row, Col } from "react-grid-system";
import styled from "styled-components";

const StyledImage = styled.img`
  max-width: 180;
  border-radius: 2px;
`;

export const DisplayAdTemplateGroup = () => {
  const { hq } = useOfficeAndHq();
  const { data: imageTemplates, isFetching } = useGetImageTemplates(hq?.id);
  const displayAdImageTemplates = imageTemplates?.filter(template =>
    template.channels.includes("displayAd")
  );

  if (isFetching) return null;
  return (
    <Stack spacing="m">
      <Box>
        <H5>{"Ad templates"} </H5>
        <Text>Not available for Delta Display ad</Text>
      </Box>
      <Stack spacing="m">
        <H5>{"Image templates"} </H5>
        <Card p="m">
          <H6>Display Ads ({displayAdImageTemplates?.length} templates)</H6>
          {displayAdImageTemplates?.map(
            (template: TemplateService.ImageTemplateModel) => (
              <Stack spacing="s" key={template.id}>
                <Text size="m">{template.name}</Text>
                <Row key={template.id}>
                  <Col md={4}>
                    <StyledImage src={template.previewUrl} />
                  </Col>

                  <Col md={8}>
                    <H6>Template url</H6>
                    <Text style={{ overflowWrap: "break-word" }} size="s">
                      {template.templateUrl}
                    </Text>
                  </Col>
                </Row>
              </Stack>
            )
          )}
        </Card>
      </Stack>
    </Stack>
  );
};
